import { Col, Modal, Row } from "antd";
import React, { useState } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import ViewPhotoModal from "../../../components/Common/ImageModal";
import { CustomTabs } from "../../../components/Common/TabBar";
import { DetailRow, getSrcValue, Section } from "./utils";

export const MedicineDetailModal = ({ visible, onClose, medicine }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [isCarouselOpen, setIsCarouselOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const HtmlDetailRow = ({ data = [] }) => (
    <Row gutter={[16, 20]}>
      {data.map((item, index) => (
        <React.Fragment key={index}>
          <Col className="fs16fw600" span={8}>
            <span style={{ color: "#4D4D4D" }}>{item.label}</span>
          </Col>
          <Col className="fs16fw600" span={16}>
            <span
              className="text-black"
              dangerouslySetInnerHTML={{ __html: item.value }}
            />
          </Col>
        </React.Fragment>
      ))}
    </Row>
  );

  const FaqSection = ({ faqs = [] }) => (
    <>
      <h6 className="text-primarycolor fs18fw600 my-3">FAQ's</h6>
      {faqs.map((item, index) => (
        <div key={index}>
          <h4 className="rxFaqTitle fs18m16fwb">
            Q{index + 1} : {item.question}
          </h4>
          <div
            className="fs18m16 fw"
            dangerouslySetInnerHTML={{ __html: item.answer }}
          />
        </div>
      ))}
    </>
  );

  const tabItems = [
    { key: "1", label: "Medicine Details" },
    { key: "2", label: "FAQ & Others" },
  ];

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={624}
      centered
      closeIcon={<IoCloseCircleOutline size={24} />}
      title={
        <span className="fw-semibold fs-5 ">{medicine.medicine_name}</span>
      }
      style={{ padding: 0, background: "#fff" }}
    >
      <div
        style={{ position: "sticky", top: 0, zIndex: 10, background: "#fff" }}
      >
        <CustomTabs
          tabs={tabItems}
          activeKey={activeTab}
          onChange={setActiveTab}
        />
      </div>

      <div
        style={{
          maxHeight: "calc(100vh - 500px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {activeTab === "1" && (
          <>
            <Section title="Medicine Details">
              <DetailRow
                data={[
                  { label: "Medicine Name", value: medicine.medicine_name },
                  {
                    label: "Package Description",
                    value: medicine.package_description,
                  },
                  { label: "Unit", value: medicine.unit?.unit },
                  { label: "Status", value: medicine.medicine_status },
                  {
                    label: "Prescription Required",
                    value: medicine.prescription_type ? "Yes" : "No",
                  },
                  {
                    label: "URL Status",
                    value: medicine.medicine_url_status ? "Active" : "Inactive",
                  },
                ]}
              />
            </Section>

            <Section title="Medicine Images">
              <Row gutter={16}>
                {medicine.photos?.map((item, index) => (
                  <Col key={index}>
                    <div
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {index === 0 && (
                        <div className="cover-label fs14fwb">Cover</div>
                      )}
                      <img
                        width={80}
                        height={100}
                        src={getSrcValue("medicines", item)}
                        alt={`Medicine ${index + 1}`}
                        style={{
                          objectFit: "cover",
                          borderRadius: 4,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setIsCarouselOpen(true);
                          setImageIndex(index);
                        }}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </Section>

            <Section title="Manufacturer Details">
              <DetailRow
                data={[
                  {
                    label: "Manufacturer",
                    value:
                      medicine?.manufacturer_name.manufacturer_name || "NA",
                  },
                  {
                    label: "Manufacturer Address",
                    value:
                      medicine?.manufacturer_name.manufacturer_address || "NA",
                  },
                  {
                    label: "Country of Origin",
                    value:
                      medicine?.manufacturer_name.country_of_origin || "NA",
                  },
                  {
                    label: "Customer Care Email",
                    value: medicine?.manufacturer_name.customer_email || "NA",
                  },
                ]}
              />
            </Section>

            <Section title="MRP & Other Details">
              <DetailRow
                data={[
                  { label: "MRP", value: `₹ ${medicine.mrp}` || "NA" },
                  {
                    label: "Discount",
                    value: `${medicine.discount} %` || "NA",
                  },
                  { label: "Quantity", value: medicine.quantity || "NA" },
                  {
                    label: "MRP Per Unit",
                    value: `₹ ${medicine.mrp_per_unit}` || "NA",
                  },
                  { label: "Unit", value: medicine.unit?.unit } || "NA",
                  {
                    label: "Returnable",
                    value: medicine.returnable ? "Yes" : "No",
                  },
                  {
                    label: "Return Window",
                    value: medicine.returnable ? "7 days" : "NA",
                  },
                  {
                    label: "Open Box Delivery",
                    value: medicine.open_box ? "Yes" : "No",
                  },
                ]}
              />
            </Section>

            <Section title="Molecule & Other Details" isLast>
              <DetailRow
                data={[
                  {
                    label: "Salt / Molecule",
                    value: medicine.salt_molecule?.molecule_name || "NA",
                  },
                  {
                    label: "Therapeutic Classification",
                    value:
                      medicine.salt_molecule?.therapeutic_classification ||
                      "NA",
                  },
                  {
                    label: "Therapeutic Uses",
                    value: medicine.therapeutic_uses || "NA",
                  },
                ]}
              />
            </Section>
          </>
        )}

        {activeTab === "2" && (
          <>
            <Section title="Additional Information">
              <HtmlDetailRow
                data={[
                  { label: "Description", value: medicine.description } || "NA",
                  {
                    label: "Warning and precautions",
                    value: medicine.warning_precaution || "NA",
                  },
                  { label: "Direction Uses", value: medicine.direction_uses } ||
                    "NA",
                  { label: "Side Effects", value: medicine.side_effects } ||
                    "NA",
                  {
                    label: "Storage Disposal",
                    value: medicine.storage_disposal || "NA",
                  },
                  { label: "Reference", value: medicine.reference || "NA" },
                  { label: "Author details", value: medicine.author_details } ||
                    "NA",
                ]}
              />
            </Section>

            <FaqSection faqs={medicine?.faq || []} />
          </>
        )}
      </div>
      {isCarouselOpen && (
        <ViewPhotoModal
          openPhotoModal={isCarouselOpen}
          setopenPhotoModal={setIsCarouselOpen}
          imageArray={medicine.photos}
          imageIndex={imageIndex}
          setImageIndex={setImageIndex}
        />
      )}
    </Modal>
  );
};
